import React from 'react'

type Props = React.PropsWithChildren<{
  fallback?: React.ReactNode
}>

// Renderiza children solo en cliente (tras el first mount)
export const ClientOnly: React.FC<Props> = ({ children, fallback = null }) => {
  const [ready, setReady] = React.useState(false)
  React.useEffect(() => setReady(true), [])
  return ready ? <>{children}</> : <>{fallback}</>
}

export default ClientOnly
